export default "__VITE_ASSET__DCz_maSQ__"